import { z } from 'zod';

export const IOStatus = z.enum([
  'no_doc',
  'completed',
  'declined',
  'recalled',
  'expired',
  'out_for_signature',
  'created'
]);
export type IOStatus = z.infer<typeof IOStatus>;

export const IOType = z.enum(['io', 'revision', 'extension']);
export type IOType = z.infer<typeof IOType>;

export const IOLineItem = z.object({
  id: z.string(),
  name: z.string().nullable(),
  tactics: z.string().nullable(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  price: z.string().nullable(),
  unit_price: z.string().nullable(),
  unit_price_type: z.string().nullable(),
  estimated_units: z.string().nullable(),
  created_time: z.string().nullable()
});
export type IOLineItem = z.infer<typeof IOLineItem>;

export const CampaignIO = z.object({
  io_id: z.string(),
  io_name: z.string(),
  io_number: z.string().nullable(),
  status: IOStatus,
  io_total: z.coerce.number().nullable(),
  start_date: z.string().nullable(),
  end_date: z.string().nullable(),
  io_type: IOType,
  completion_date: z.string().nullable(),
  line_item_count: z.coerce.number(),
  line_items: z.array(IOLineItem),
  io_created_time: z.string().nullable(),
  created_by_name: z.string().nullable()
});
export type CampaignIO = z.infer<typeof CampaignIO>;
